module.exports = {
  "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
  "day": "\u0434\u0435\u043D\u044C",
  "dayPeriod": "\u0434\u043F/\u043F\u043F",
  "endDate": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
  "era": "\u0435\u0440\u0430",
  "hour": "\u0433\u043E\u0434\u0438\u043D\u0430",
  "minute": "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
  "month": "\u043C\u0456\u0441\u044F\u0446\u044C",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.startDate, " \u2014 ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0447\u0430\u0441: ".concat(args.time);
  },
  "startDate": "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
  "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441",
  "weekday": "\u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F",
  "year": "\u0440\u0456\u043A"
};